export interface IJob {
  title: string;
  period: string;
  tasks: Array<string>;
}

export interface IJobDescription {
  company: string;
  description: IJob;
}

export const jobs: Array<IJobDescription> = [
  {
    company: "BPREVEN (ביפריוון)",
    description: {
      title: "Web developer(React+TS)",
      period: "February 2023 - present",
      tasks: [
        "Develop and implement user interface components “from-scratch” using React.js, Git, Node.js, Redux Toolkit, REST API and ES6+",
        "Work with designers and other team members in a startup environment",
        "Write clean, well-tested code that is easy to maintain, build reusable components",
        "Translate Figma designs and wireframes into high-quality code",
        "Creating documentation and usage guidelines, define the API schema",
      ],
    },
  },
  {
    company: "Yandex",
    description: {
      title: "Web developer",
      period: "September 2021 - March 2023",
      tasks: [
        "Student at web development course including front and back end",
        "Writing well designed, testable, efficient code by using best software development practices",
        "Built two real web projects in team",
        "Testing web applications",
      ],
    },
  },
  {
    company: "Yandex.Practicum",
    description: {
      title: "Teaching Assistant",
      period: "January 2022 - December 2022",
      tasks: [
        "Provide support and assistance to Web Development students to help them better understand the content and help them to complete assignments",
        "Cultivate a positive and organized learning atmosphere",
      ],
    },
  },
  {
    company: "European University in St. Petersburg",
    description: {
      title: "Frontend developer",
      period: "October - November 2022",
      tasks: [
        "Building a multiple page web application according to Figma layouts and specifications",
        "Used technologies: HTML, CSS, React, Typescript, Redux Toolkit + RTK Query, React Router Dom v6",
      ],
    },
  },
  {
    company: "CNImmigration, ARProjects, Reshafim",
    description: {
      title: "Administration jobs",
      period: "February 2013 - November 2019",
      tasks: [
        "Leading immigration, import/export and administrative projects",
        "Preparation of complete application kits for a legal immigration process to Canada. Help to more than 1000 families to move to Canada and find work",
        "Conducting continuous communications with Canadian Immigration Authorities",
        "Hebrew/Russian to English translations",
      ],
    },
  },
  {
    company: "Saber Interactive",
    description: {
      title: "HR and localization manager",
      period: "May 2007 - October 2012",
      tasks: [
        "Job adverts, personnel search, interviews, new hire orientation. Translation and interpretation. During my work the company`s grown up from 50 to almost 200 tech specialists in St.Petersburg department",
        "Game localization (translation, editing, proofreading and testing localized versions)",
      ],
    },
  },
];

export interface IProject {
  title: string;
  description: string;
  tech: string;
  link: string;
}
export const projects: Array<IProject> = [
  {
    title: "WishesService - backend",
    description:
      "Backend for web application where authorized users can create wishes, wishlists, make offers for other`s wishes, change their profile etc.",
    tech: "Nest.js, Typescript, PostgreSQL + TypeORM",
    link: "https://github.com/ElenaSolov/kupipodaridai-backend",
  },
  {
    title: "Biking",
    description: "Adaptive one page application for bikes saler",
    tech: "HTML, CSS, JavaScript",
    link: "https://github.com/ElenaSolov/biking",
  },
  {
    title: "React Burger",
    description: "Burger builder with DND",
    tech: "React, Typescript, Redux, React DND, Web-sockets",
    link: "https://github.com/ElenaSolov/react-burger",
  },
  {
    title: "Algososh",
    description:
      "React application which animates basic algorithms and data structions(like Fibonacci, Bubble and Selection sorting, stack, queue and linked list",
    tech: "React, Typescript, React Router, Jest, Cypress",
    link: "https://github.com/ElenaSolov/algososh",
  },
  {
    title: "Lived",
    description:
      'React Web app built for "Lived" center of the European University in St. Petersburg (https://prozhito.org/page/about).',
    tech: "React, Typescript, React Router, Redux Toolkit + RTK Query",
    link: "https://github.com/ElenaSolov/prozhito-project",
  },
  {
    title: "Places - backend",
    description:
      "Server side for Instagram-like single page website, with authentication, authorization, input validation, DB connection and logging, where users can edit their profile and change the avatar, as well as add and delete their images. Furthermore, users can like pictures of their own and the other people that are connected to the server.",
    tech: "Mongodb+Mongoose, Typescript, Node.js + Express, Bcrypt, Jsonwebtoken, Winston + express-winston for logging ",
    link: "https://github.com/ElenaSolov/mesto-project-plus",
  },
  {
    title: "Places - frontend",
    description:
      "Client side for Instagram-like single page website, with authentication, authorization, input validation, where users can edit their profile and change the avatar, as well as add and delete their images. Furthermore, users can like pictures of their own and the other people that are connected to the server.",
    tech: "HTML, CSS, Javascript",
    link: "https://github.com/ElenaSolov/mesto-project-plus",
  },
  {
    title: "Flophouse",
    description:
      "Page with register form for adaptive site of non-profit organization homeless.ru (https://www.facebook.com/Homeless.ru). Each step of the form rendered according to the previous user choice.",
    tech: "HTML, CSS, Javascript",
    link: "https://github.com/ElenaSolov/flophouse",
  },
  {
    title: "Across Russia",
    description: "An adaptive web-site wish CSS animations",
    tech: "HTML, CSS",
    link: "https://github.com/ElenaSolov/russian-travel",
  },
];
